// // frontend/src/components/ChatPage.js

// import { useParams } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';

// export default function ChatPage() {
//   const { phoneno } = useParams();
//   const [history, setHistory] = useState([]);
//   const [input, setInput] = useState('');
//   const bottomRef = useRef(null);
//   const API_URL = process.env.REACT_APP_API_URL;

//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [history]);

//   const sendMessage = async () => {
//     if (!input.trim()) return;
//     setHistory(h => [...h, { role: 'user', text: input }]);
//     const msg = input;
//     setInput('');

//     try {
//       const { data } = await axios.post(
//         `${API_URL}/chat/${encodeURIComponent(phoneno)}`,
//         { input: msg }
//       );
//       setHistory(h => [
//         ...h,
//         { role: 'agent', text: data.reply }
//       ]);
//     } catch {
//       setHistory(h => [...h, { role: 'agent', text: 'Error contacting server.' }]);
//     }
//   };

//   return (
//     <div style={{ display: 'flex', height: '100vh' }}>
//       <div style={{ flex: 1, padding: 20, overflowY: 'auto', borderRight: '1px solid #eee' }}>
//         {history.filter(m => m.role === 'user').map((m, i) => (
//           <div key={i} style={{ margin: '8px 0' }}>
//             <strong>You:</strong> {m.text}
//           </div>
//         ))}
//       </div>
//       <div style={{ flex: 1, padding: 20, overflowY: 'auto' }}>
//         {history.filter(m => m.role === 'agent').map((m, i) => (
//           <div key={i} style={{ margin: '8px 0' }}>
//             <strong>Agent:</strong> {m.text}
//           </div>
//         ))}
//         <div ref={bottomRef} />
//       </div>
//       <div style={{
//         position: 'fixed',
//         bottom: 0, left: 0, right: 0,
//         display: 'flex', padding: 10,
//         background: '#fafafa', borderTop: '1px solid #ddd'
//       }}>
//         <input
//           value={input}
//           onChange={e => setInput(e.target.value)}
//           onKeyDown={e => e.key === 'Enter' && sendMessage()}
//           placeholder="Type a message…"
//           style={{ flex: 1, padding: 10, fontSize: '1rem' }}
//         />
//         <button onClick={sendMessage} style={{ marginLeft: 10, padding: '0 20px' }}>
//           Send
//         </button>
//       </div>
//     </div>
//   );
// }

// import { useParams } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import './ChatPage.css';

// export default function ChatPage() {
//   const { phoneno } = useParams();
//   const [history, setHistory] = useState([]);
//   const [input, setInput] = useState('');
//   const bottomRef = useRef(null);
//   const API_URL = process.env.REACT_APP_API_URL;

//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
//   }, [history]);

//   const sendMessage = async () => {
//     if (!input.trim()) return;
//     setHistory(h => [...h, { role: 'user', text: input }]);
//     const msg = input;
//     setInput('');

//     try {
//       const { data } = await axios.post(
//         `${API_URL}/chat/${encodeURIComponent(phoneno)}`,
//         { input: msg }
//       );
//       setHistory(h => [...h, { role: 'agent', text: data.reply }]);
//     } catch {
//       setHistory(h => [...h, { role: 'agent', text: 'Error contacting server.' }]);
//     }
//   };

//   return (
//     <div className="chat-container">
//       <div className="chat-history">
//         {history.map((msg, i) => (
//           <div key={i} className={`chat-message ${msg.role}`}>
//             <div className="bubble">{msg.text}</div>
//           </div>
//         ))}
//         <div ref={bottomRef} />
//       </div>
//       <div className="chat-input-container">
//         <input
//           value={input}
//           onChange={e => setInput(e.target.value)}
//           onKeyDown={e => e.key === 'Enter' && sendMessage()}
//           placeholder="Type a message…"
//         />
//         <button onClick={sendMessage}>Send</button>
//       </div>
//     </div>
//   );
// }


import { useParams } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './ChatPage.css';

export default function ChatPage() {
  const { phoneno } = useParams();
  const [history, setHistory] = useState([]);
  const [input, setInput] = useState('');
  const bottomRef = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL || "https://your-render-service.onrender.com";

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [history]);

  const sendMessage = async () => {
    if (!input.trim()) return;
    setHistory(h => [...h, { role: 'user', text: input }]);
    const msg = input;
    setInput('');

    try {
      const { data } = await axios.post(
        `${API_URL}/chat/${encodeURIComponent(phoneno)}`,
        { input: msg }
      );
      setHistory(h => [...h, { role: 'agent', text: data.reply }]);
    } catch {
      setHistory(h => [...h, { role: 'agent', text: 'Error contacting server.' }]);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-history">
        {history.map((msg, i) => (
          <div key={i} className={`chat-message ${msg.role}`}>
            <div className="bubble">
              <div className="sender">{msg.role === 'user' ? '🧍You' : '🤖Agent'}</div>
              <div>{msg.text}</div>
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
      <div className="chat-input-container">
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && sendMessage()}
          placeholder="Type a message…"
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}
